import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CompareTypeEnum } from '../enums/compare-type.enum';

function clearCompareErrors(control: AbstractControl) {
  if (control.hasError('greaterThan')) {
    delete control.errors.greaterThan;
    control.updateValueAndValidity();
  }
  if (control.hasError('lessThan')) {
    delete control.errors.lessThan;
    control.updateValueAndValidity();
  }
  if (control.hasError('greaterThanOrEqual')) {
    delete control.errors.greaterThanOrEqual;
    control.updateValueAndValidity();
  }
  if (control.hasError('lessThanOrEqual')) {
    delete control.errors.lessThanOrEqual;
    control.updateValueAndValidity();
  }
  if (control.hasError('equal')) {
    delete control.errors.equal;
    control.updateValueAndValidity();
  }
}

export function EqualsSumValidator(compareControl: AbstractControl, values: AbstractControl[], equalsSum: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!compareControl || !compareControl.value || !control || !control.value) {
      return {};
    }

    let sum = 0;
    values.forEach((v) => {
      sum = sum + Number(v.value);
    });

    if (isNaN(sum) === false && sum !== equalsSum) {
      return { equalsSumValues: true };
    } else if (isNaN(sum) === false && sum === equalsSum) {
      for (const v of values) {
        if (v.hasError('equalsSumValues')) {
          delete v.errors.equalsSumValues;
          v.updateValueAndValidity();
        }
      }
    }

    return {};
  };
}

export function CompareValidatorNumberConvert(compareControl: AbstractControl, compareTypeEnum: CompareTypeEnum): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!compareControl || !compareControl.value || !control || !control.value) {
      return {};
    }

    if (compareTypeEnum === CompareTypeEnum.GREATER_THAN) {
      if (Number(control.value) <= Number(compareControl.value)) {
        return { greaterThan: true };
      }
    } else if (compareTypeEnum === CompareTypeEnum.LESS_THAN) {
      if (Number(control.value) >= Number(compareControl.value)) {
        return { lessThan: true };
      }
    } else if (compareTypeEnum === CompareTypeEnum.GREATER_THAN_OR_EQUAL) {
      if (Number(control.value) < Number(compareControl.value)) {
        return { greaterThanOrEqual: true };
      }
    } else if (compareTypeEnum === CompareTypeEnum.LESS_THAN_OR_EQUAL) {
      if (Number(control.value) > Number(compareControl.value)) {
        return { lessThanOrEqual: true };
      }
    } else if (compareTypeEnum === CompareTypeEnum.EQUAL) {
      if (Number(control.value) !== Number(compareControl.value)) {
        return { equal: true };
      }
    }
    clearCompareErrors(compareControl);
    return {};
  };
}

export function CompareValidator(compareControl: AbstractControl, compareTypeEnum: CompareTypeEnum): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!compareControl || !compareControl.value || !control || !control.value) {
      return {};
    }
    if (compareTypeEnum === CompareTypeEnum.GREATER_THAN) {
      if (control.value <= compareControl.value) {
        return { greaterThan: true };
      }
    } else if (compareTypeEnum === CompareTypeEnum.LESS_THAN) {
      if (control.value >= compareControl.value) {
        return { lessThan: true };
      }
    } else if (compareTypeEnum === CompareTypeEnum.GREATER_THAN_OR_EQUAL) {
      if (control.value < compareControl.value) {
        return { greaterThanOrEqual: true };
      }
    } else if (compareTypeEnum === CompareTypeEnum.LESS_THAN_OR_EQUAL) {
      if (control.value > compareControl.value) {
        return { lessThanOrEqual: true };
      }
    } else if (compareTypeEnum === CompareTypeEnum.EQUAL) {
      if (control.value !== compareControl.value) {
        return { equal: true };
      }
    }
    clearCompareErrors(compareControl);
    return {};
  };
}
